module.exports = __webpack_public_path__ + "static/media/4050.de827b2a.jpg";